import { Suspense, lazy } from 'react';
import { createPortal } from 'react-dom';

const LazyEventCollectorDevTool = lazy(
  () => import('./hooks/context/EventCollector/EventCollectorDevTool'),
);

export default function DevTools() {
  return createPortal(
    import.meta.env.VITE_FEATURE_EVENT_COLLECTOR_DEVTOOL === 'true' ? (
      <Suspense fallback={null}>
        <LazyEventCollectorDevTool />
      </Suspense>
    ) : null,

    document.querySelector('#dev')!,
  );
}
